<dgx-search-field-wrapper (click)="focusRoleSearch()" class="guts-m-h-2-half">
  <input
    #rolesSearchInput
    id="rolesSearch"
    type="text"
    role="combobox"
    [(ngModel)]="roleSearchTerm"
    name="roleSearch"
    [placeholder]="i18n.Onboarding_SearchRoles_SearchForRole"
    [attr.aria-label]="i18n.Onboarding_SearchRoles_SearchForRole"
    [attr.aria-expanded]="isPopoverOpen"
    aria-controls="search-popover-role"
    aria-autocomplete="list"
    aria-haspopup="listbox"
    (input)="onInputChange($event)"
    autocomplete="off"
    data-dgat="role-search-0c2"
    [ngClass]="{ 'input-spinner': loadingResults }"
  />
  <!-- popover element for suggested job roles -->
  <dgx-popover
    #popoverComponent
    role="listbox"
    id="search-popover-role"
    [(isOpen)]="isPopoverOpen"
    (isOpenChange)="onIsPopoverOpenChange($event)"
    [popoverTrigger]="rolesSearchInputRef"
    [focusFirstItem]="false"
    [placementAdjustLeftRem]="2"
    placement="bottom-left"
    class="__typeahead-popup"
  >
    <!--Search input auto suggest menu contents. role=menu and role=menuitem are both a11y attributes AND custom directives that enable keyboard navigation-->
    <div class="scrollable __search-menu" role="menu">
      <ng-container
        *ngFor="let suggestion of suggestions"
        class=""
        data-dgat="role-search-5f7"
      >
        <button
          class="l_flexbar guts-p-v-1 guts-p-l-0 guts-p-r-1 listbox--option"
          role="menuitem"
          (click)="addRole(suggestion)"
          data-dgat="role-search-e21"
        >
          <div class="guts-m-h-1">
            {{ suggestion.title }}
          </div>
        </button>
      </ng-container>
    </div>
  </dgx-popover>
</dgx-search-field-wrapper>
